import { useContext } from "react";
import { LanguageContext } from "./LanguageContext";
import { translations } from "./translations";

export const MultiLingualContent = ({ contentId, prop }) => {
  const { language } = useContext(LanguageContext);
  return prop ? translations[language][contentId][prop] : translations[language][contentId];
};
